import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { common, financedEmissions } from "../../i18n";
import { LoanStatus } from "../../models/dto/cat15/cat15.types";

interface Props {
  status: LoanStatus;
  size?: "small" | "medium";
}

/** Loan status pill — Figma node 6091:50410 (active green / closed grey). */
const LoanStatusChip = ({ status, size = "small" }: Props) => {
  const { t } = useTranslation([financedEmissions, common], {
    nsMode: "fallback",
  });
  const active = status === "active";
  return (
    <Chip
      size={size}
      label={active ? t("Status-Active") : t("Status-Closed")}
      sx={{
        borderRadius: "10px",
        fontWeight: 600,
        color: active
          ? "var(--status-approved-complete-active-text)"
          : "var(--status-draft-inactive-text)",
        backgroundColor: active
          ? "var(--status-approved-complete-active-bg)"
          : "var(--status-draft-inactive-bg)",
      }}
    />
  );
};

export default LoanStatusChip;
